import * as React from 'react';

import { Grid, Select, Spacer, TextField, Typography } from '@emburse/ui-core';

import { ICardsGatewayIssuingModalValues } from '@Actions/cardsGatewayIssuingModalActions';

import { STATE_OPTIONS } from '@ReactConstants/cardIssuing';

interface IAddressFormProps {
  recipient?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phoneNumber?: string;
  onChange: (update: Partial<ICardsGatewayIssuingModalValues>) => void;
  includePhoneNumberField?: boolean;
}

export const AddressFormBase: React.FC<IAddressFormProps> = ({ onChange, ...rest }) => {
  let formTitle = 'Shipping Address';
  if (rest.includePhoneNumberField) {
    formTitle = 'Shipping Address and Contact';
  }
  return (
    <Grid container spacing={2}>
      <Spacer size={20} />
      <Grid item xs={12}>
        <Typography variant="subtitle1">{formTitle}</Typography>
      </Grid>
      <ShippingAddressForm onChange={onChange} {...rest} />
    </Grid>
  );
};

const ShippingAddressForm: React.FC<Partial<IAddressFormProps>> = ({
  recipient,
  street,
  city,
  state,
  zipCode,
  phoneNumber,
  includePhoneNumberField,
  onChange
}) => (
  <>
    <Grid item xs={12}>
      <TextField
        type="text"
        fullWidth
        label="Recipient name"
        required
        value={recipient}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ addressRecipient: e.target.value })}
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        type="text"
        fullWidth
        label="Street address"
        required
        value={street}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ addressStreet: e.target.value })}
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        type="text"
        fullWidth
        label="City"
        required
        value={city}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ addressCity: e.target.value })}
      />
    </Grid>
    <Grid item xs={6}>
      <Select
        fullWidth
        native
        className="grow-1"
        value={state}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ addressState: e.target.value })}
        label="State"
        required
      >
        <option value="" aria-label="none" />
        {STATE_OPTIONS.map((stateOption) => (
          <option key={stateOption.value} value={stateOption.value}>
            {stateOption.label}
          </option>
        ))}
      </Select>
    </Grid>
    <Grid item xs={12}>
      <TextField
        type="text"
        fullWidth
        label="Zip Code"
        required
        value={zipCode && zipCode.toString()}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ addressZipCode: e.target.value })}
      />
    </Grid>
    {includePhoneNumberField && (
      <Grid item xs={12}>
        <TextField
          type="text"
          fullWidth
          label="Phone Number"
          value={phoneNumber && phoneNumber.toString()}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ addressPhoneNumber: e.target.value })}
        />
      </Grid>
    )}
  </>
);

export const AddressForm = React.memo(AddressFormBase);
